import ReactOnRails from 'react-on-rails';
import { Application } from "@hotwired/stimulus"
import SignupPasswordAlertController from "../controllers/signup_password_alert_controller"

import * as Desktop from "components/layout/header/desktop";
import * as Mobile from "components/layout/header/mobile";
import LanguageSelect from "components/layout/header/LanguageSelect";

const signupPasswordAlertApp = Application.start()
signupPasswordAlertApp.register("signup-password-alert", SignupPasswordAlertController)

ReactOnRails.register({
  "Header::Desktop::UserControls": Desktop.UserControls,
  "Header::Mobile::Navigation": Mobile.Navigation,
  "Header::LanguageSelect": LanguageSelect,
  "Header::Desktop::UserControls::Reactivation": Desktop.UserControls,
});
